import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { init } from 'echarts';
import { round } from 'mathjs';

import Color from '@tool/color';

interface IProps {
  height: number,
  xData: any[],
  yData: any[],
}
interface IState {}

const Chart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  let chart: any = null;
  const chart19Ref = useRef<any>(null);
  const colorList = [Color.cf, Color.secondary, Color.primary, '#86D4E0'];
  const { xData, yData, height } = props;

  const render = () => {
    if (chart) chart.dispose();
    chart = init(chart19Ref.current);

    const series: any[] = [];
    yData.map((item: any) => {
      series.push({
        ...item,
        type: 'bar',
        barWidth: '10px',
        itemStyle: {
          borderRadius: [2, 2, 0, 0],
        },
      });
    });

    const option = {
      color: colorList,
      legend: {
        bottom: 10,
        itemWidth: 8,
        itemHeight: 8,
      },
      grid: {
        // width: `${width}px`,
        left: 10,
        right: 10,
        bottom: 40,
        top: 30,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLine: {
          show: true,
          lineStyle: { color: Color.ccc },
        },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          color: Color.blackColor(0.85),
        },
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        type: 'value',
        axisTick: { show: false },
        axisLabel: {
          show: true,
          fontSize: 12,
          color: Color.blackColor(0.5),
          fontFamily: 'Roboto',
        },
        axisLine: {
          lineStyle: { color: Color.da },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.primaryColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      series: series,
    };

    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [xData, yData]);

  return (
    <section ref={chart19Ref}
      style={{
        width: '100%',
        height: `${height}px`,
      }} />
  );
};

export default observer(Chart);
